/* eslint-disable no-useless-catch */
// HTTP Services
import StockService from "services/http/endpoints/stock";
import PricingService from "services/http/endpoints/pricing";
import FinancialService from "services/http/endpoints/financial";
import ConfigService from "services/http/endpoints/baazar-configs";

function useStock() {
	async function getAssetInfo() {
		try {
			const assets = await StockService.search();

			return assets.result;
		} catch (error) {
			throw error;
		}
	}

	async function getAssetsPrice() {
		try {
			return await PricingService.assetsPrice();
		} catch (error) {
			throw error;
		}
	}

	async function getConfigs() {
		try {
			return await ConfigService.getConfigs();
		} catch (error) {
			throw error;
		}
	}

	async function getAssetsPriceByDay(day: number) {
		try {
			const data = await PricingService.price(day);
			return data;
		} catch (error) {
			throw error;
		}
	}

	async function getFinancials() {
		try {
			return await FinancialService.search({ size: 100000 });
		} catch (error) {
			throw error;
		}
	}

	return {
		getConfigs,
		getAssetInfo,
		getAssetsPrice,
		getAssetsPriceByDay,
		getFinancials,
	};
}

export default useStock;
